import * as Yup from 'yup'

export const initialValues = {
    company: '',
    email: '',
    firstName: '',
    lastName: '',
}

export const validationSchema = Yup.object().shape({
    company: Yup.string().required('Company is required'),
    email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
})
